import dataSender from './ApiService';

export function registerToGlobalPool(candidateId, questionnaire,customerName){
    return dataSender('/api/v2/candidates/global-pool', {apiKey: sessionStorage.getItem('apiKey-'+customerName), candidateId : candidateId, questionnaire: questionnaire}, 'PUT');
}

